// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"392":"50568bed","683":"5c9e975b"}[chunkId] + ".chunk.js";
};